import type { VaultLatestProfile } from '@ducat-unit/core';
import { get_vault_action_vout_idx } from '@ducat-unit/core/lib';

import { wait } from '@/lib/util';

import { type ApiError, get } from './http';

/** Both the mint and vault transactions must confirm before this index wait. */
export async function poll_opened_vault(
  root_txid: string,
  client_pubkey: string,
  validator_url: string,
  signal?: AbortSignal,
  timeout_ms = 10 * 60_000,
  canReadVaultHistory?: () => boolean,
) {
  const started = Date.now();
  while (true) {
    if (signal?.aborted) throw new DOMException('Polling cancelled', 'AbortError');
    if (canReadVaultHistory?.() === false) return;
    let vault: VaultLatestProfile | undefined;
    try {
      vault = await get<VaultLatestProfile>(`${validator_url}/api/vault/${encodeURIComponent(root_txid)}/latest`, undefined, { signal });
    } catch (error) {
      if ((error as ApiError).status !== 404) throw error;
    }
    if (signal?.aborted) throw new DOMException('Polling cancelled', 'AbortError');
    if (canReadVaultHistory?.() === false) return;
    if (vault) {
      if (
        vault.root_txid !== root_txid ||
        vault.client_pubkey !== client_pubkey ||
        vault.vault_action !== 'open' ||
        vault.coin_id !== `${root_txid}:${get_vault_action_vout_idx('open')}`
      ) {
        throw new Error('Opening vault identity mismatch');
      }
      if (vault.state !== 'active') throw new Error('Opening vault is not active');
      return;
    }
    if (Date.now() - started >= timeout_ms) throw new Error(`Timeout: opening vault ${root_txid} is not indexed`);
    await wait(3000, signal);
  }
}
